module.exports = __webpack_public_path__ + "img/keittokatos_original.e045a709.jpg";